import { COMPANY } from '@/config/company';

export const WHATSAPP_MESSAGES = {
  home: {
    candidate: `Olá! Visitei o site da ${COMPANY.tradingName} e gostaria de me cadastrar como candidato. Pode me orientar?`,
    company: `Olá! Visitei o site da ${COMPANY.tradingName} e gostaria de contratar profissionais para minha empresa. Quero receber informações sobre as soluções de recrutamento e mão de obra disponíveis.`,
  },
  comercial:
    'Olá! Gostaria de contratar profissionais para minha empresa. Quero receber informações sobre as soluções de recrutamento e mão de obra disponíveis.',
  suporte: `Olá! Preciso de atendimento da ${COMPANY.tradingName}. Já sou cliente.`,
  recrutamento:
    'Olá! Tenho interesse no serviço de Recrutamento e Seleção e gostaria de uma proposta comercial.',
  maoObraTemporaria:
    'Olá! Tenho interesse no serviço de Mão de Obra Temporária e gostaria de uma proposta comercial.',
  terceirizacao:
    'Olá! Tenho interesse no serviço de Terceirização de Serviços e gostaria de uma proposta comercial.',
  hunting:
    'Olá! Tenho interesse no serviço de Hunting de Executivos e gostaria de uma proposta comercial.',
  avaliacao:
    'Olá! Tenho interesse no serviço de Avaliação de Perfil e gostaria de uma proposta comercial.',
  seguranca:
    'Olá! Tenho interesse no serviço de Segurança Patrimonial e gostaria de uma proposta comercial.',
  controleAcesso:
    'Olá! Tenho interesse no serviço de Controle de Acesso e gostaria de uma proposta comercial.',
  portaria:
    'Olá! Tenho interesse no serviço de Portaria Inteligente e gostaria de uma proposta comercial.',
  limpeza:
    'Olá! Tenho interesse no serviço de Limpeza Profissional e gostaria de uma proposta comercial.',
  zeladoria:
    'Olá! Tenho interesse no serviço de Zeladoria Preventiva e gostaria de uma proposta comercial.',
  facilities:
    'Olá! Tenho interesse no serviço de Facilities e gostaria de uma proposta comercial.',
  sobre: `Olá! Gostaria de saber mais sobre a ${COMPANY.tradingName} e nossos serviços de recrutamento e RH.`,
  servicos: `Olá! Visitei o site da ${COMPANY.tradingName} e gostaria de conhecer melhor os serviços oferecidos.`,
  services: `Olá! Visitei o site da ${COMPANY.tradingName} e gostaria de conhecer melhor os serviços oferecidos.`,
  clients: `Olá! Tenho interesse em saber mais sobre as empresas atendidas pela ${COMPANY.tradingName}.`,
  clientes: `Olá! Tenho interesse em saber mais sobre as empresas atendidas pela ${COMPANY.tradingName}.`,
  parceiros: `Olá! Tenho interesse em ser parceiro da ${COMPANY.tradingName} e gostaria de receber mais informações.`,
  partners: `Olá! Tenho interesse em ser parceiro da ${COMPANY.tradingName} e gostaria de receber mais informações.`,
  fornecedores: `Olá! Tenho interesse em fornecer serviços para a ${COMPANY.tradingName}.`,
  suppliers: `Olá! Tenho interesse em fornecer serviços para a ${COMPANY.tradingName}.`,
  careers: `Olá! Tenho interesse em trabalhar na ${COMPANY.tradingName} e gostaria de saber mais sobre as oportunidades.`,
  process: `Olá! Tenho interesse no Processo Seletivo da ${COMPANY.tradingName} e gostaria de me candidatar.`,
  faq: `Olá! Tenho algumas dúvidas sobre a ${COMPANY.tradingName} e gostaria de obter mais informações.`,
  contact: `Olá! Entrei em contato pelo site da ${COMPANY.tradingName} e gostaria de receber mais informações.`,
  contactForm: `Olá! Preenchi o formulário de contato no site da ${COMPANY.tradingName} e gostaria de ser atendido.`,
  whatsappButton: `Olá! Vi o botão de WhatsApp no site da ${COMPANY.tradingName} e gostaria de conversar sobre recrutamento ou oportunidades.`,
  budgetForm:
    'Olá! Preenchi o formulário no site e gostaria de solicitar um orçamento para minha empresa. Quero receber informações sobre as soluções e serviços disponíveis.',
  candidateForm: `Olá! Acabei de enviar meu currículo pelo site da ${COMPANY.tradingName}. Gostaria de saber mais sobre o processo de recrutamento.`,
  divulgarVaga:
    'Olá! Gostaria de divulgar uma vaga para minha empresa. Quero receber orientação sobre o processo de divulgação e recrutamento.',
  solicitarServico: `Olá! Gostaria de receber informações sobre os serviços da ${COMPANY.tradingName} para minha empresa.`,
} as const;
